import { KeyIcon } from './KeyIcon';

/**
 * author: Google
 * id D6208581-CF7F-438A-8578-B6ADEE462212
 * name key
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/key.svg
 * tags
 * - Automotive 
 */
export const VpnKeyIcon = KeyIcon;
export default VpnKeyIcon